<ion-select
  [label]="'company.title' | translate"
  label-placement="floating"
  fill="outline"
  (ionChange)="selectedItemChanged.emit($event.detail.value)"
  [multiple]="multiple"
  [value]="preselectedItem"
  mode="md"
  interface="popover"
>
  @if (showAllEntry) {
  <ion-select-option [value]="null">{{
    "company.all" | translate
  }}</ion-select-option>
  } @for (item of this.items; track item) {
  <ion-select-option [value]="item">{{ item.name }}</ion-select-option>
  }
</ion-select>
